import { AxiosResponse } from "axios";
import { apiClient } from "@/api/apiClient";
import * as Sentry from "@sentry/browser";
import { API_PATHS } from "@/constants/apiPaths";

const SamsubAPI = {
  async getAccessToken(id: string): Promise<string> {
    try {
      const response: AxiosResponse<string> = await apiClient.post(
        API_PATHS.GET_ACCESS_TOKEN,
        {
          id,
        },
      );

      return response.data;
    } catch (error) {
      Sentry.captureException(error);
      throw new Error("Failed to fetch blocks");
    }
  },
};

export const { getAccessToken } = SamsubAPI;
